import { render } from "./activity-header.vue?vue&type=template&id=30375050"
import script from "./activity-header.vue?vue&type=script&lang=js"
export * from "./activity-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__